<template>
  <div id="app">
    <v-app>
      <router-view class="" />
      <CookieBanner />
    </v-app>
  </div>
</template>

<style>
:root {
  /* 🎨 Цвета */
  --color-primary: #171F43;
  --color-primary-dark: #00172E; 
  --color-primary-codepopup: #00009B;
  --color-primary-light: #3851fa;
  --color-primary-popup: #920F2A;
  --color-white: #FFFFFF;
  --color-accent: #f2e4b5;
  --color-error: #eb5757;
  --color-error-dark: #ad0202;
  --color-black: #020202;

  /* 🔤 Шрифты */
  --font-family: "DrukCyrMedium", sans-serif;
  --font-family-heavy: "DrukCyrHeavy", sans-serif;
  --font-family-regular: "BrandonRegular", sans-serif;
  --font-family-book: "BebasNeueBook", sans-serif;
  --font-family-bold: "Brandon", sans-serif;
  --font-family-medium: "BrandonMedium", sans-serif;
  --font-family-addition: "MontserratRegular",sans-serif;
  --font-family-bold:"BebasNeueBold",sans-serif;
  --font-family-cyr:"BebasNeueCyr",sans-serif;

  /* 📏 Размеры шрифтов */
  --font-size-xxl: 40px;
  --font-size-xl: 36px;
  --font-size-lg: 24px;
  --font-size-md: 20px;
  --font-size-sm: 18px;
  --font-size-xs: 16px;
  --font-size-xxs: 14px;
  --font-size-xxxs: 12px;

  /* 📦 Отступы и радиусы */
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 20px;

  --padding-sm: 10px;
  --padding-md: 20px;
  --padding-lg: 42px;

  /* 🖱️ Эффекты */
  --transition-fast: 0.15s ease-out;
  --transition-normal: 0.3s ease-in-out;
  --transition-slow: 0.4s ease;
  --box-shadow-btn: 0 4px 0 var(--color-primary-dark);
  --box-shadow-btn-hover: 0 6px 0 var(--color-primary-dark);
  --box-shadow-btn-active: 0 2px 0 var(--color-primary-dark);
}

</style>
<script>
import CookieBanner from '@/components/CookieBanner.vue';

export default {
  name: "App",
  components: {
    CookieBanner
  }
};
</script>
